<template>
    <div class="pt-15">
        <h5 class="header-stripe">
            <span>{{$t('INDENT_TRUCK_IN')}}</span>
            <div class="action">
                <Button type="secondary" size="mini" @click="$emit('cancelAction')">{{$t('INDENT_CANCEL')}}</Button>
                <Button type="primary" size="mini" @click="truckIn">{{$t('INDENT_SUBMIT')}}</Button>
            </div>
        </h5>
        <div class="py-15">
            <Form :inline="true" class="form-default form-triple">
                <div class="form-item-group mb-0 ">
                    <FormItem border="none" background="none" class="text-left mr-20">
                        <div>
                          <RadioGroup v-model="selectedGate" display="block">
                            <Radio
                              v-for="source in mappedGates"
                              :label="source.unique_id"
                              :disabled="!!(source.arrived_at && source.dispatched_at)"
                              :key="source.unique_id">
                              {{source.gateName}}
                            </Radio>
                          </RadioGroup>
                        </div>
                    </FormItem>
                    <FormItem :label="$t('INDENT_DATE_AND_TIME')" class="mt-10">
                        <Date-Picker
                          :clearable="true"
                          :value="truckInDate"
                          :format="datePickerFormat"
                          type="datetime"
                          :placeholder="$t('INDENT_SELECT_DATE_AND_TIME')"
                          :picker-options="pickerOptions1"
                          @input="changeTruckInDate($event)">
                        </Date-Picker>
                    </FormItem>
                </div>
            </Form>
        </div>
    </div>
</template>
<script>

export default {
  props: {
    sources: {
      type: Array,
      default: () => [],
    },
    datePickerFormat: {
      type: String,
      default: 'dd-MM-yyyy hh:mm A',
    },
    isStorageLocation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      truckInDate: '',
      selectedGate: null,
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  created() {
    const selectedGate = this.gateList.filter(gate =>
      gate.arrived_at === null && gate.dispatched_at === null);
    this.selectedGate = (selectedGate[0] && selectedGate[0].unique_id) || null;
  },
  computed: {
    mappedGates() {
      if (this.isStorageLocation) {
        const listGates = this.gateList;
        const gates = listGates.map((lgt) => {
          const currentGate = this.$depot.gate(lgt.gateId, lgt.location_id);
          return {
            ...lgt,
            ...currentGate,
          };
        });
        const { groupedStorage, nonStorageItems } = gates.reduce(
          (acc, item) => {
            if (item.is_storage_location) {
              const locationId = item.location_id || '';
              if (!acc.groupedStorage[locationId]) {
                acc.groupedStorage[locationId] = {
                  items: [],
                  names: [],
                  ids: [],
                };
              }
              acc.groupedStorage[locationId].items.push(item);
              acc.groupedStorage[locationId].names.push(item.name || '');
              acc.groupedStorage[locationId].ids.push(item.gate_id); // collect storage items
            } else {
              acc.nonStorageItems.push(item); // collect non-storage items
            }
            return acc;
          },
          {
            groupedStorage: {},
            nonStorageItems: [],
          },
        );
        // Combine storage groups per location_id
        const combinedStorageObjects = Object.values(groupedStorage).map(group => ({
          ...group.items[0], // pick first as base
          gateName: `${group.names.join(', ')} ( Storage Location )`,
          combinedStorageGateIds: group.ids.join(','),
        }));
        
        const final = [...combinedStorageObjects, ...nonStorageItems];
        return final;
      }
      return this.gateList;
    },
    gateList() {
      return this.sources.reduce((acc, element) => {
        const gateData = element.address.gates.filter(gate => gate._id === element.gate_id);
        acc.push({
          unique_id: element._id,
          gateId: element.gate_id,
          location_id: element.location_id,
          gateName: gateData[0].name,
          arrived_at: element.arrived_at,
          dispatched_at: element.dispatched_at,
        });
        return acc;
      }, []);
    },
  },
  methods: {
    changeSelected(source) {
      this.selectedGate = source;
    },
    changeTruckInDate(date) {
      this.truckInDate = date;
    },
    async truckIn() {
      const data = {
        arrived_at: this.truckInDate,
        unique_id: this.selectedGate,
      };
      this.$emit('truckIn', data);
    },
  },
};
</script>
